import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchMatter,
  fetchNotification,
  updateNotification,
} from "../service/matter";

export const fetchMatterList = createAsyncThunk(
  "matterlist/fetch",
  async ({page,status,case_type,sort_order,sort_by, page_size,search, assigned_to_me}, { rejectWithValue }) => {
    try {
      const response = await fetchMatter(page,status,case_type,sort_order,sort_by, page_size || 10,search, assigned_to_me);
     return response;
    } catch (error) {
      return rejectWithValue(error.message || "Unable to fetch matter list");
    }
  }
);

export const fetchNotifications = createAsyncThunk(
  "notificationlist/fetch",
  async (
    {
      offset,
      limit,
      unread,
      timeFilter,
      customFilter,
      customDate,
      startDate,
      endDate,
      append, //DO NOT REMOVE : Used in extra reducers
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchNotification({
        offset,
        limit,
        unread,
        timeFilter,
        customFilter,
        customDate,
        startDate,
        endDate,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || "Unable to fetch notification list"
      );
    }
  }
);

export const updateNotificationStatus = createAsyncThunk(
  "notificationlist/patch",
  async (notification_ids, { rejectWithValue }) => {
    try {
      console.log("notification_ids",notification_ids)
      const response = await updateNotification(notification_ids);
     return response;
    } catch (error) {
      return rejectWithValue(error.message || "Unable to update notification list");
    }
  }
)

const MatterSlice = createSlice({
  name: "matter",
  initialState: {
    matterList: [],
    totalPages: 0,
    totalRecords: 0,
    status: "idle", // idle, loading, succeeded, failed
    error: null,
    sort:"asc",
    item:"display_name",
    currentPage: 1,
    pageSize: 25,
    selectedValue:null,
    selectedValueCaseType:null,
    // Default to "My Matters" — full firm-wide list is hundreds of rows and
    // each /matter visit re-fetches it, which the user observed as a slow load.
    // Most attorneys land here looking for their own caseload; the toggle
    // remains a one-click affordance for managing partners / staff who need
    // the firm-wide view. (2026-04-29)
    assignedToMe:true,
    search:"",
    inputValue:"",
    notifications: {
      items: [],
      totalCount: 0,
      unreadCount: 0,
      moreNotifications: false,
    },
    hasMore:false,
  },
  reducers: {
    updateSort(state,action) {
      state.sort = action.payload.sort;
      state.item = action.payload.item;
    },
    setCurrentPage(state,action) {
      state.currentPage = action.payload;
    },
    setPageSize(state,action) {
      state.pageSize = action.payload;
    },
    setSelectedValue(state,action) {
      state.selectedValue = action.payload;
    },
    setSelectedValueCaseType(state,action) {
      state.selectedValueCaseType = action.payload;
    },
    setAssignedToMe(state,action) {
      state.assignedToMe = action.payload;
    },
    setSearch(state,action) {
      state.search = action.payload;
    },
    setInputValue(state,action){
      state.inputValue = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatterList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMatterList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.matterList = action.payload.data.results;
        state.totalPages = ((action.payload.data.count % 10 ) > 0)?((action.payload.data.count / 10) + 1):(action.payload.data.count / 10);
        state.totalRecords = action.payload.data.count;
      })
      .addCase(fetchMatterList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchNotifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        const shouldAppend = action.meta.arg.append;
        state.status = "succeeded";
        const { results, count, unread_count, has_more } = action.payload.data;
        state.notifications.items = shouldAppend
        ? [...state.notifications.items, ...results]
        : results;
        state.notifications.totalCount = count;
        state.notifications.unreadCount = unread_count;
        state.notifications.moreNotifications = has_more;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});
export const {
  updateSort,
  setCurrentPage,
  setSelectedValueCaseType,
  setSelectedValue,
  setAssignedToMe,
  setSearch,
  setInputValue,
  setPageSize,
} = MatterSlice.actions;
export default MatterSlice.reducer;
